import { render, staticRenderFns } from "./IklanLelang.vue?vue&type=template&id=0ce9e168"
import script from "./IklanLelang.vue?vue&type=script&lang=js"
export * from "./IklanLelang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports